import { Component, Input, OnInit } from '@angular/core';
import { GuiChildConfig } from '../../gui.interface';
import { IFormGridConfig, IFormGridGroup, IFormGridKeyValue } from './form-grid.interface';
import { TranslateService } from '../../../../services/translate/translate.service';

@Component({
  selector: 'form-grid',
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss']
})
export class FormGridComponent implements OnInit {
  private _config: any;
  public gridConfig: IFormGridConfig;

  @Input()
  set config(v: any) {
    this._config = v;
    this.initializeGrid();
  }

  get config(): any {
    return this._config;
  }

  constructor(
    private ts: TranslateService
  ) { }

  ngOnInit(): void {
    if (!this.gridConfig) {
      this.initializeGrid();
    }
  }

  private initializeGrid(): void {
      this.gridConfig = this._config;
  }

  // private createDefaultColumns(): IFormGridColumn[] {
  //   const columns: IFormGridColumn[] = [];
  //
  //   // Create 3 columns
  //   for (let i = 0; i < 10; i++) {
  //     columns.push({
  //       title: this.ts.translate(`devicestate.grid.column${i + 1}`),
  //       keyValues: this.createEmptyKeyValues()
  //     });
  //   }
  //
  //   return columns;
  // }

  // private createEmptyKeyValues(): IFormGridKeyValue[] {
  //   const keyValues: IFormGridKeyValue[] = [];
  //
  //   // Create example key-value pairs with status icons
  //   const exampleData: IFormGridKeyValue[] = [
  //     { key: 'Status', value: 'Online', status: 'success' },
  //     { key: 'Connection', value: 'Stable', status: 'success' },
  //     { key: 'Temperature', value: '78°C', status: 'error' },
  //     { key: 'Uptime', value: '24 days', status: 'success' }
  //   ];
  //
  //   return exampleData;
  // }
}
